import { render, staticRenderFns } from "./companyMingAdd.vue?vue&type=template&id=2c7324b3"
import script from "./companyMingAdd.vue?vue&type=script&lang=js"
export * from "./companyMingAdd.vue?vue&type=script&lang=js"
import style0 from "./companyMingAdd.vue?vue&type=style&index=0&id=2c7324b3&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports